const mutations = {
  SET_PROCESSING(state, value) {
    state.processing = value;
  },
  SET_TAXES(state, value) {
    state.taxes = value;
  },
  SET_SHOW_TAXES(state, value) {
    state.showTaxes = value;
  },
  SET_IMPORT_RESULT(state, value) {
    state.importResult = value;
  },
  SET_PAGE(state, value) {
    state.page = value;
  },
  SET_PAGE_SIZE(state, value) {
    state.pageSize = value;
  },
  SET_TOTAL_ITEMS(state, value) {
    state.totalItems = value;
  },
  SET_TOTAL_PAGES(state, value) {
    state.totalPages = value;
  },
};

export default mutations;
